require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./post-first-laravel-tutorial-controllers-and-routes.json") })
        }
      }, "path---post-first-laravel-tutorial-controllers-and-routes");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---post-first-laravel-tutorial-controllers-and-routes!./.cache/json/post-first-laravel-tutorial-controllers-and-routes.json
// module id = 324
// module chunks = 231608221292675